/**
* 
* ## match map between beds and add ons
* 
* ```json
* {
*  [add ons variant id ]:{
*     pIds:[bed ids],  //
*     num:1,           // how many beds that should be matched.
*  }
* }
* ```
* 
*/
window.initAddonsWidget = () => {
    const addonsMapBeds = document.querySelector('.add-on-map-beds');
    if (addonsMapBeds) {
    
        /**
         *  display not match add ons tips
         * @param id : add ons variant ids
         */
        const handleLineItemAddonTips = (ids) => {
            if (!!ids.length) {
                ids.forEach(vid => {
                    let lineItemEls = document.querySelectorAll(
                      `.cart-area.cart-area-items [data-v-id="${vid}"] .ajaxcart__row`
                    );
                    Array.from(lineItemEls).forEach(el => {
                        let tipsEl = el.querySelector('.add-on-tips-inline')
                        if (!tipsEl) {
                            tipsEl = document.createElement('div')
                            tipsEl.className = 'add-on-tips-inline'
                            el.appendChild(tipsEl)
                        }
                        tipsEl.innerHTML = `<span><b><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.80994 1.14319C11.4917 1.14336 14.476 4.12839 14.476 7.81018C14.4758 11.4918 11.4916 14.476 7.80994 14.4762C4.12815 14.4762 1.14312 11.4919 1.14294 7.81018C1.14294 4.12828 4.12804 1.14319 7.80994 1.14319ZM7.80408 7.14319C7.43601 7.14319 7.13729 7.44216 7.13708 7.81018V10.4762C7.13708 10.8444 7.43589 11.1432 7.80408 11.1432C8.17211 11.143 8.47107 10.8443 8.47107 10.4762V7.81018C8.47087 7.44228 8.17199 7.14337 7.80408 7.14319ZM7.80408 4.85706C7.43601 4.85706 7.13729 5.15603 7.13708 5.52405C7.13708 5.89224 7.43589 6.19104 7.80408 6.19104H7.80994C8.1779 6.19078 8.47693 5.89208 8.47693 5.52405C8.47673 5.15619 8.17778 4.85732 7.80994 4.85706H7.80408Z" fill="#9A4A27"/>
</svg></b>This add-on is not compatible with the selected product.</span>`;
                    })
                })

            };

        }
        const addonTips = (res) => {
            let find_res = res.find((item) => !item.isMatchBed);
            const el = document.querySelector('.add-on-tips');
            const cautionEl = document.querySelector('.add-on-tips');
            if (!find_res) {
              cautionEl.style.display = "none";
            } else {
              cautionEl.style.display = "flex";
              el.style.display = "block";
              handleLineItemAddonTips(Object.keys(find_res.addons ?? {}));
              Popper.createPopper(el.querySelector("span")); //, this.$dropdown[0], options)
            }
        }
        const parseIdMatchV2 = (cart, bedVariantIds, bedIds, matchMap) => {
          const beds_pid_in_cart = [];
          const beds_vid_in_cart = [];
          const p_v_id_map = {};
         

          let is_no_match_rule = !!matchMap.no_match;
          let add_on_pIds = [],
            add_on_pIds_match_v_id = []; // no match rule that add on ids
          const idNumsMap_variant = cart.items.reduce(
            (res, item) => {
              if (is_no_match_rule && matchMap[item.product_id]){
                add_on_pIds.push(item.product_id);
                add_on_pIds_match_v_id.push(item.variant_id);
              }
              if (matchMap[item.variant_id]) res.addons[item.variant_id] = [item.variant_id];
              p_v_id_map[item.variant_id] = item.product_id;
              if (bedIds.indexOf(item.product_id) > -1) {
                // v_id of beds in cart
                if (beds_pid_in_cart.indexOf(item.product_id) == -1)
                  beds_pid_in_cart.push(item.product_id);
              }
              if (bedVariantIds.indexOf(item.variant_id) > -1) {
                // p_id of beds in cart
                if (beds_vid_in_cart.indexOf(item.variant_id) == -1)
                  beds_vid_in_cart.push(item.variant_id);
              }
              return res;
            },
            { addons: {} },
          );

          
           if(is_no_match_rule){
            let addons_in_cart =  []
            add_on_pIds.filter((add_on_id,index) => {
               let find_res = matchMap[add_on_id].pIds.filter((pid) =>beds_pid_in_cart.includes(pid));
               if (find_res.length) addons_in_cart.push(add_on_pIds_match_v_id[index]);
             }); 
            return {
               isMatchBed: addons_in_cart.length == 0,
               addons: addons_in_cart.reduce((res,item)=>{
                res[item]= item;
                return res;
               },{}),
            };
           }
          //exclude beds pid and add on id in same product
          // 1. beds
          let _beds_pid_in_cart = beds_pid_in_cart;
          Object.keys(idNumsMap_variant.addons).forEach((addonVariantId) => {
            let bed_p_id = p_v_id_map[addonVariantId];
            _beds_pid_in_cart = _beds_pid_in_cart.filter(
              (item) => item != bed_p_id,
            );
          });
          let res_1 = judgeMatchBeds(
            _beds_pid_in_cart,
            beds_vid_in_cart,
            idNumsMap_variant,
            // p_v_id_map,
            matchMap,
          );
          if (!res_1.isMatchBed) return res_1;
          // 2. exclude add ons
          Object.keys(idNumsMap_variant.addons).forEach((addonVariantId) => {
            let bed_p_id = p_v_id_map[addonVariantId];
            if (beds_pid_in_cart.find((item) => item == bed_p_id)) {
              delete idNumsMap_variant.addons[addonVariantId];
            }
          });
          return judgeMatchBeds(
            beds_pid_in_cart,
            beds_vid_in_cart,
            idNumsMap_variant,
            // p_v_id_map,
            matchMap,
          );
        };
        const judgeMatchBeds = (
          beds_pid_in_cart,
          beds_vid_in_cart,
          idNumsMap_variant,
          //p_v_id_map
          matchMap,
        ) => {
          let addons_arr = Object.keys(idNumsMap_variant.addons);
          if (!beds_vid_in_cart.length && !beds_pid_in_cart.length)
            return { isMatchBed: true };
          if (!addons_arr.length) return { isMatchBed: true };
          let add_ons = Object.keys(idNumsMap_variant.addons).find(
            (addonVariantId) => {
              let pIds_set = Array.from(
                new Set([
                  ...matchMap[addonVariantId].pIds,
                  ...beds_pid_in_cart,
                ]),
              );
              let vIds_set = Array.from(
                new Set([
                  ...(matchMap[addonVariantId].vIds ?? []),
                  ...beds_vid_in_cart,
                ]),
              );
              let intersect_set =
                pIds_set.length <
                matchMap[addonVariantId].pIds.length + beds_pid_in_cart.length;
              let intersect_set_v =
                vIds_set.length <
                (matchMap[addonVariantId].vIds ?? []).length +
                  beds_vid_in_cart.length;
              return intersect_set_v || intersect_set;
            },
          );
          return {
            isMatchBed: !!add_ons,
            addons: idNumsMap_variant.addons ?? {},
          };
        };
        const handle = (cart) => {
            try {
                window.tc = cart.items;
                const matchMapArr = JSON.parse(
                      addonsMapBeds.textContent.trim(),
                    );
                return matchMapArr.map((matchMap) => {
                    const bedIds = Array.from(
                      new Set(
                        Object.values(matchMap)
                          .map((item) => item.pIds)
                          .flat(2),
                      ),
                    );
                    const bedVariantIds = Array.from(
                      new Set(
                        Object.values(matchMap)
                          .map((item) => item.vIds)
                          .flat(2)
                          .filter((item) => item),
                      ),
                    );
                    return parseIdMatchV2(
                      cart,
                      bedVariantIds,
                      bedIds,
                      matchMap,
                    );
                });
                    
            } catch (error) {
                console.log(error)
                return []
            }
        }
        window.handleMatchAddonsAndBeds = (cart) => {
            try {
                cart.items = cart.items.filter((item) => item.quantity > 0);
                addonTips(handle(cart))
            } catch (error) {
                console.log(error)
            }
        }

    }
}